import { render, staticRenderFns } from "./TopHeader.vue?vue&type=template&id=0949f7f2&scoped=true"
import script from "./TopHeader.vue?vue&type=script&lang=ts"
export * from "./TopHeader.vue?vue&type=script&lang=ts"
import style0 from "./TopHeader.vue?vue&type=style&index=0&id=0949f7f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0949f7f2",
  null
  
)

export default component.exports